import { Component } from 'react';
import styled from '@emotion/styled';
import WarrantyFooter from './footer';

import { ASSET_URLS } from './utils';

const { ArrowIcon, DarkArrowIcon } = ASSET_URLS;

import Page from './page';
import WarrantyPage from './warranty';
import DocumentPage from './documents';
import FAQPage from './faqs';



const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 40px;
  justify-content: center;
  border-bottom: 1px solid rgb(202, 202, 202);
  & ${TabWrapper}:nth-child(2) {
     border-left: 1px solid rgb(202, 202, 202); 
     border-right: 1px solid rgb(202, 202, 202); 
    };
`;

const TabWrapper = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  background-color: ${ props => props.backgroundColor };
  justify-content: center;
`;

const TabInnerSpan = styled.div`
  font-family: OCRoboto;
  font-size: 16px;
  font-weight: light;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props => props.fontColor};
  text-align: center;
  padding-top: 11px;
`;

const TabLink = styled.a`
  color: ${props => props.fontColor};
  font-weight: normal;
  &:hover {
    cursor: pointer;
    text-decoration: ${props => !props.active ? 'underline' : 'none' };
    color: ${props => props.hoverFontColor};
  }
`;





class Tab extends Component {

  handleClick = () => this.props.tabHandler(this.props.index);

  render() {
    return (
      <TabWrapper
        backgroundColor={this.props.active ? '#d40f7d' : '#FFF'}
        fontColor={this.props.active ? '#FFF' : '#000'}
        onClick={this.handleClick}
        data-track='tab-click'
      >
        <TabInnerSpan
          fontColor={this.props.active ? '#FFF' : '#000'}
        >
          <TabLink
            fontColor={this.props.active ? '#FFF' : '#000'}
            hoverFontColor={this.props.active ? '#FFF' : '#d40f7d'}
          >
            {this.props.children}
          </TabLink>
        </TabInnerSpan>
      </TabWrapper>
    )
  }
}



class Tabs extends Component {
  state = {
    activeTab: this.props.activeTab || 0,
  }

  tabHandler = (selectedTab) => {
    this.setState({ activeTab: selectedTab });
  }

  render() {
    const {availableTabs} = this.props;
    const {activeTab} = this.state;

    return(
      <div>
        <TabsContainer>
          {
            availableTabs.map((tab, index) => {
              return (
                <Tab
                  active={this.state.activeTab === index}
                  key={index}
                  index={index}
                  tabHandler={this.tabHandler}
                >
                  <span>
                    {tab.title}
                  </span>
                </Tab>
              );
            })
          }
        </TabsContainer>

        {availableTabs.map((tab, index) => {
          if (index !== activeTab) {
            return null;
          }

          return (
            <div key={index}>
              {tab.element}
            </div>
          )
        })}
      </div>
    )
  }
}




export default class WarrantyNav extends Component {

    state = {
      activeTab: 0,
    }

    render() {
        return(
            <Tabs
              activeTab={this.state.activeTab}
              availableTabs={[
                {
                  title: 'Warranties',
                  element: <WarrantyPage activeWarranties={this.props.activeWarranties} />,
                },
                {
                  title: 'FAQs',
                  element: <FAQPage />,
                },
                {
                  title: 'Documents',
                  element: <DocumentPage activeWarranties={this.props.activeWarranties} />,
                },
              ]}
            />
        )
    }
}





